/**
 * 浏览器环境下的 API 根 URL（不含路径；与 api.ts 中 `${base}/api/...` 拼接）。
 * CRA 会把 REACT_APP_* 打进包内；若写成 http://127.0.0.1:5055，用户通过公网 IP
 * 打开站点时浏览器会向「访客本机」发请求，并触发 Private Network / CORS 限制。
 */
export function getApiPublicBase(): string {
  const raw = process.env.REACT_APP_API_BASE || '';
  const envBase = raw.replace(/\/$/, '');

  if (typeof window === 'undefined') {
    return envBase;
  }

  const { hostname, port } = window.location;
  const isLocalHost =
    hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';

  if (isLocalHost && port === '3000') {
    return envBase || 'http://127.0.0.1:5055';
  }

  const pointsToLoopback =
    envBase !== '' &&
    (/http:\/\/127\.0\.0\.1(?::\d+)?\/?$/i.test(envBase) ||
      /http:\/\/localhost(?::\d+)?\/?$/i.test(envBase));

  if (!isLocalHost && pointsToLoopback) {
    return '';
  }

  return envBase;
}
